import { render, staticRenderFns } from "./ModalDocumentForm.vue?vue&type=template&id=27963bd6"
import script from "./ModalDocumentForm.js?vue&type=script&lang=js&external"
export * from "./ModalDocumentForm.js?vue&type=script&lang=js&external"
import style0 from "./ModalDocumentForm.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports